export default {
  ADD_PARTNER: 'AddPartner',
  CONSTITUTION: 'Constitution',
  CAPITAL_INCREASE: 'CapitalIncrease',
  CAPITAL_DECREASE: 'CapitalDecrease',
  HERITAGE: 'Heritage',
  DONATION: 'Donation',
  TRANSMISSION: 'Transmission',
  BUY: 'Buy',
  SELL: 'Sale',
  SPLIT: 'Split',
  RENUMERATION: 'Renumeration',
  RECLASSIFICATION: 'Reclassification',
  CONTRIBUTION: 'OtherContributions',
  ENDORSEMENT: 'Endorsement',
};
